import { Variants } from '@amplitude/experiment-js-client';

import { AppDispatch } from '@/redux/store';
import { hasGuideArticlesTreatment } from '@/utils/amplitude/experiments/hooks/useGuideArticles.experiment';

import { fetchArticleRelatedItems } from './articleRelatedItems.actions';

type FetchArticleRelatedItemsIfCurrentParams = {
    amplitudeExperimentFlags: Variants;
    dispatch: AppDispatch;
    keyword: string | null | undefined;
};

/**
 * Fetches related item ids only when treatment is on and a keyword exists.
 */
export const fetchArticleRelatedItemsIfCurrent = ({
    amplitudeExperimentFlags,
    dispatch,
    keyword,
}: FetchArticleRelatedItemsIfCurrentParams) => {
    if (!keyword || !hasGuideArticlesTreatment(amplitudeExperimentFlags)) {
        return Promise.resolve();
    }

    return dispatch(fetchArticleRelatedItems({ keyword }));
};
